// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__rk-ay","btn_fill":"Button_btn_fill__Irbek"};